import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=84a8f53a&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts&setup=true"
export * from "./Orders.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Orders.vue?vue&type=style&index=0&id=84a8f53a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a8f53a",
  null
  
)

export default component.exports